import React from "react";
import hero from "../../../assets/featuers/heroFeatures.png";
import langs from "../../../assets/featuers/langs.png";
import muliBranches from "../../../assets/featuers/muliBranches.png";
import cutomeize from "../../../assets/featuers/cutomeize.png";
import adds from "../../../assets/featuers/adds.png";
import social from "../../../assets/featuers/socailMedia.png";
import sort from "../../../assets/featuers/sort.png";
import support from "../../../assets/featuers/suport.png";
import tags from "../../../assets/featuers/tags.png";
import upates from "../../../assets/featuers/updates.png";

import Layout from "../Layout";
import { useTranslation } from "react-i18next";
import Iterator from "../../utils/Iterator";
import { motion } from "framer-motion";

function FeaturesPage() {
  const { t } = useTranslation();
  // const featuress = features(t);

  const item = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };
  const features = [
    { key: "multiLanguages", img: langs },
    { key: "multiBranches", img: muliBranches },
    { key: "designCustomization", img: cutomeize },
    { key: "easyUpdates", img: upates },
    { key: "tagsOffers", img: tags },
    { key: "optionsAddons", img: adds },
    { key: "productSorting", img: sort },
    { key: "socialIntegration", img: social },
    { key: "customerSupport", img: support },
  ];

  return (
    <Layout title={t("pages.features")}>
      {/* Hero Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl font-bold mb-4">
              {t("features.heroTitle")}
            </h1>
            <p className="text-lg text-secondary-foreground mb-6">
              {t("features.heroDesc")}
            </p>
          </div>
          <div>
            <img src={hero} alt="Features" className="rounded-lg shadow-md" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-muted">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">
            {t("features.ourFeatures")}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <Iterator
              data={features}
              render={(feature, i) => (
                <motion.div
                  variants={item}
                  key={feature.key}
                  className="bg-background rounded-xl shadow-sm p-6 hover:shadow-md transition"
                >
                  <img
                    src={feature.img}
                    alt={feature.key}
                    className="w-full aspect-square mb-4"
                  />
                  <h3 className="text-xl font-semibold mb-3 text-MainBlue">
                    {t(`features.${feature.key}.title`)}
                  </h3>
                  <p className="text-secondary-foreground">
                    {t(`features.${feature.key}.desc`)}
                  </p>
                </motion.div>
              )}
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 text-center">
        <h2 className="text-3xl font-bold mb-6">{t("features.ctaTitle")}</h2>
        <a
          href="https://wa.me/971528401112?text=Hello%21+I+found+TWHMENU.com+and+I+want+to+create+digital+menu"
          className="bg-MainBlue text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-600 transition"
        >
          {t("features.ctaButton")}
        </a>
      </section>
    </Layout>
  );
}

export default FeaturesPage;
